export default {"src":"/_next/static/media/atlantic.39066021.svg","height":16,"width":104,"blurWidth":0,"blurHeight":0};